import 'babel-polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import {Router, Route, hashHistory} from 'react-router';
import SingleBook from './components/single_book/SingleBook';
import WordList from './components/WordList/WordList'
import BookList from './components/book_list/BookList'
import PressList from './components/press_list/PressList'
import GankaoApp from './components/gankaoapp/GankaoApp'
import WordDetail from './components/word_detail/WordDetail'
import './index.css';
import fetch from "isomorphic-fetch";
import TongBu from "./components/word_detail/TongBu";
import TongBuShuFa from './components/word_detail/TongBuShuFa'
import GanKao from "./components/gankao/GanKao";
import Word from "./components/gankao/Word";

// `//bishunfile.qiaoxuesi.com/book_data.json?v=${Math.random()}`
fetch(`//bishunfile.qiaoxuesi.com/book_data.json?v=${Math.random()}`, {
    method: 'GET'
}).then(
    function (response) {
        if (response.status !== 200) {
            console.log("初始化获取全局数据,存在一个问题，状态码为：" + response.status);
            return;
        }
        response.json().then(function (data) {
            window.AllBooksForPress = data;
            let route = <Router history={hashHistory}>
                {/*三甲*/}
                <Route path="/" components={PressList}>
                    <Route path="/press/:presspinyin" component={BookList}>
                        {/*<Route path="/press/:presspinyin/book/:bookId/subject/:name" components={SingleBook}>*/}
                        {/*<Route path="/press/:presspinyin/book/:bookId/word/:wordId/subject/:name" components={WordList}/>*/}
                        {/*</Route>*/}
                        <Route path="/press/:presspinyin/book/:bookId" components={SingleBook}>
                            <Route path="/press/:presspinyin/book/:bookId/word/:wordId" components={WordList}/>
                        </Route>
                    </Route>
                </Route>
                {/*赶考*/}
                <Route path="/gankao" components={GankaoApp}>
                    <Route path="/WordDetail" component={WordDetail}>
                    </Route>
                    <Route path="/TongBu" component={TongBu}>
                    </Route>
                    <Route path="/TongBuShuFa" component={TongBuShuFa}>
                    </Route>
                </Route>

                <Route path="/gankao2" components={GanKao}>
                    <Route path="/Word" component={Word}>
                    </Route>
                    <Route path="/TongBu" component={TongBu}>
                    </Route>
                    <Route path="/TongBuShuFa" component={TongBuShuFa}>
                    </Route>
                </Route>
            </Router>
            ReactDOM.render(
                route,
                document.getElementById('root')
            );
        });
    }
).catch(function (err) {
    console.log("Fetch错误:" + err);
});









// WEBPACK FOOTER //
// ./src/index.js